import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Video from 'twilio-video';
import axios from 'axios';
import { withStyles } from '@mui/styles';
import { Button, Dialog, DialogActions, DialogContent, FormControl, FormLabel, Grid, MenuItem, TextField } from "@mui/material";
import html2canvas from "html2canvas";
import DeleteIcon from '@mui/icons-material/Delete';
import CircularProgress from '@mui/material/CircularProgress';
import Select from '@mui/material/Select';
import { toast } from 'react-toastify';

const styles = (theme) => ({
  localVideo: {
    width: '100%',
    height: '100%',
  },
  localVideoOnConnect: {
    position: 'absolute',
    width: 'auto',
    height: 'calc(100% - 80%)',
    right: 'calc(100% - 95%)',
    bottom: 'calc(100% - 92.1%)',
  },
  remoteVideoOnConnect: {
    width: '100% !important',
    height: '100% !important',
  },
  localVideoContainer: {
    position: 'relative',
  },
  remoteVideoContainer: {
    padding: '5%',
  },
});

class TwilioVideo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      identity: null /* Will hold the name assigned to the client. */,
      roomName: '' /* Will store the room name */,
      roomNameErr: false /* Track error for room name TextField. This will    enable us to show an error message when this variable is true */,
      previewTracks: null,
      localMediaAvailable: false /* Represents the availability of a LocalAudioTrack(microphone) and a LocalVideoTrack(camera) */,
      hasJoinedRoom: false,
      activeRoom: null, // Track the current active room
      capturedImages: [],
      currentImage: 0,
      viewerIsOpen: false,
      viewRejectReasons: false,
      rejectItems: [],
      showInnerSpinner: false,
      consultStatus: false
    };
    this.joinRoom = this.joinRoom.bind(this);
    this.leaveRoom = this.leaveRoom.bind(this);
  }

  componentDidMount() {
    this.props.onRef(this);
    console.log('Connected to Twilio: ' + this.props.identity);
    return axios
      .get(
        `${process.env.REACT_APP_BASEURL}twilioToken/${this.props.identity +
          ' Remote'}/${this.props.roomName}`,
        {
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
            'Content-Type': 'application/json',
          },
        }
      )
      .then((response) => {
        /*
          Make an API call to get the token and identity(fake name) and  update the corresponding state variables.
          */
        const { identity, token } = response.data;
        this.setState({ identity, token });
        console.log('Identity state: ' + this.state.identity);
        this.joinRoom();
        setTimeout(() => {
          this.fetchExistingIds();
        }, 2000);
      });
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  leaveRoom() {
    this.state.activeRoom.disconnect();
    this.state.activeRoom.localParticipant.tracks.forEach((track) => {
      track.stop();
      track.disable();
    });
    return axios
      .get(
        `${process.env.REACT_APP_BASEURL}twilioToken/${this.props.roomName}/completed`,
        {
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
            'Content-Type': 'application/json',
          },
        }
      )
      .then(({ data }) => {
        console.log('Room disconnected!!!!!', data);
        this.setState({ hasJoinedRoom: false, localMediaAvailable: false });
      });
  }

  joinRoom() {
    const { classes } = this.props;
    console.log('Trying to connect to Twilio with token', this.state.token);
    let previewContainer1 = this.remoteMedia;
    Video.connect(this.state.token, {
      video: { 
        frameRate: 24
      },
      audio: true,
      name: this.props.roomName,
      bandwidthProfile: {
        video: {
          mode: 'grid'
        }
      },
      maxAudioBitrate: 16000,
      networkQuality: {local:1, remote: 1}
    })
      .then((room) => {
        this.setState({
          activeRoom: room,
          localMediaAvailable: true,
          hasJoinedRoom: true,
        });
        console.log('Connected to Twilio');
        // Get the camera track for your preview.
        const cameraTrack = [...room.localParticipant.videoTracks.values()][0]
          .track;
        this.localMedia.appendChild(cameraTrack.attach());
        let video = document.getElementById('local');
        if (video.children[1]) {
          video.children[1].className = classes.localVideo;
        }
        function removeParticipant(participant) {
          console.log(
            'Removing participant with identity',
            participant.identity
          );
          const elem = document.getElementById('remote');
          elem.parentNode.removeChild(elem);
          let localVideo = document.getElementById('local');
          if (localVideo.children[1]) {
            localVideo.children[1].className = classes.localVideo;
          }
        }
        function addParticipant(participant) {
          console.log('Adding a new Participant');
          participant.tracks.forEach((publication) => {
            if (
              publication &&
              publication.value &&
              publication.value.isSubscribed
            ) {
              const track = publication.value.track;
              track.attach && previewContainer1.appendChild(track.attach());
              let remoteVideo = document.getElementById('remote');
              let localVideo = document.getElementById('local');
              if (localVideo.children[1]) {
                localVideo.children[1].className = classes.localVideoOnConnect;
              }
              if (remoteVideo.children[1]) {
                remoteVideo.children[1].className =
                  classes.remoteVideoOnConnect;
              }
              console.log('Attached a track');
            }
          });
          participant.on('trackSubscribed', (track) => {
            track.attach && previewContainer1.appendChild(track.attach());
            let remoteVideo = document.getElementById('remote');
            let localVideo = document.getElementById('local');
            if (localVideo.children[1]) {
              localVideo.children[1].className = classes.localVideoOnConnect;
            }
            if (remoteVideo.children[1]) {
              remoteVideo.children[1].className = classes.remoteVideoOnConnect;
            }
          });
        }
        room.participants.forEach(addParticipant);
        room.on('participantConnected', addParticipant);
        room.on('participantDisconnected', removeParticipant);
      })
      .catch((e) => {
        console.log('An Error happened', e);
      });
  }

  capturePhoto = () => {
    let canvasPromise = html2canvas(this.remoteMedia, {
      useCORS: true
    });
    canvasPromise.then((canvas)=> {
      var dataURL = canvas.toDataURL("image/png", 0.5);
      this.setState(prevState => ({
        capturedImages: [...prevState.capturedImages, dataURL]
      }));
    });
  };

  openLightbox = (event, index) => {
    this.setState({
      currentImage: index,
      viewerIsOpen: true
    });
  };

  closeLightbox = () => {
    this.setState({
      currentImage: 0,
      viewerIsOpen: false
    });
  };

  removeImage = (e, idx) => {
    const { capturedImages } = this.state;
    const remainingItems = capturedImages.filter((item) => item !== capturedImages[idx]);
    if(remainingItems.length > 0) {
      this.setState({ capturedImages: remainingItems });
    } else {
      this.setState({ capturedImages: [] });
    }
  }

  showRejection = () => {
    this.listOfReasons();
  }

  listOfReasons = () => {
    try {
      this.setState({ showInnerSpinner: true })
      fetch(
        process.env.REACT_APP_BASEURL + "consultation/reject/reasons-list",
        {
          method: "GET",
          withCredentials: true,
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession
                .idToken.jwtToken,
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          if (res && res.data) {
            this.setState({
              rejectItems: res.data,
              viewRejectReasons: true,
              showInnerSpinner: false,
            });
          }
        });
    } catch(error){
      console.log(error)
    }
  }

  AcceptRejectConsultation = (e, type) => {
    e && e.preventDefault();
    const { capturedImages } = this.state;
    const { roomName, selectedReasonId, setIdCaptureType } = this.props;
    setIdCaptureType(type)
    if (capturedImages.length > 0) {
      this.setState({ showInnerSpinner: true })
      let objArray = [];
      capturedImages.map(async (item) => {
        let data = {
          pickup_code: roomName,
          type: type,
          image_url: item,
          selected_reason: selectedReasonId || "630ea51e-ca12-437e-a749-e7bc7897e96f"
        };
        objArray.push(data);
      });
      fetch(
        `${process.env.REACT_APP_BASEURL}consultation/id-capture/accept-reject`,
        {
          method: "POST",
          withCredentials: true,
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
                .jwtToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(objArray),
        }
      ).then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      }).then((data) => {
          if(data && data.status && data.status === 200) {
            this.setState({ viewRejectReasons: false, showInnerSpinner: false, consultStatus: true })
          } else {
            this.setState({ viewRejectReasons: false, showInnerSpinner: false, consultStatus: false })
            if(type === 0) {
              toast.error(`Error while accepting captured ids! Please contact administrator.`);
            } else {
              toast.error(`Error while rejecting captured ids! Please contact administrator.`);
            }
          }
        })
        .catch((error) => {
          console.log(
            `Error while uploading captured images ${error && error.message}`
          );
          toast.error(error && error.message);
          this.setState({ viewRejectReasons: false, showInnerSpinner: false, consultStatus: false });
        });
    }
  };

  fetchExistingIds = () => {
    const { roomName } = this.props;
    fetch(
      `${process.env.REACT_APP_BASEURL}consultation/fetch-ids/${roomName}`,
      {
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((existingIdsRes) => {
        if (
          existingIdsRes &&
          existingIdsRes.data &&
          existingIdsRes.data.length > 0
        ) {
          const Ids = existingIdsRes.data.map((x) => {
            return x.image_url;
          });
          this.setState({ capturedImages: Ids });
        }
      })
      .catch((error) => {
        console.log(
          `Error while uploading captured images ${error && error.message}`
        );
      });
  };  
  
  render() {
    const { classes, t, submitSelectedRejection, selectedReasonId, setSelectedReasonText, selectedReasonText } = this.props;
    const {
      capturedImages,
      viewerIsOpen,
      currentImage,
      viewRejectReasons,
      showInnerSpinner,
      rejectItems,
      consultStatus
    } = this.state;
    return (
      <div>
        <div>
          <div
            id="local"
            ref={(ref) => (this.localMedia = ref)}
            className={classes.localVideoContainer}
          >
            <div
              id="remote"
              ref={(ref) => (this.remoteMedia = ref)}
              className={classes.remoteVideoContainer}
            />
          </div>
          <Button onClick={this.capturePhoto} className={classes.primaryButton}>
            Capture
          </Button>
        </div>
        <div style={{ overflowY: "auto" }}>
          <Grid
            container
            sx={{
              flexWrap: "nowrap",
              display: "flex",
            }}
          >
            {capturedImages &&
              capturedImages.map((src, index) => (
                <Grid
                  item
                  style={{
                    maxWidth: "250px !important",
                    display: "inline-grid",
                  }}
                >
                  <img
                    key={index}
                    src={src}
                    alt={`Snapshot ${index}`}
                    onClick={(e) => {
                      this.openLightbox(e, index);
                    }}
                    style={{ width: "250px", cursor: "pointer" }}
                  />
                  <Button
                    onClick={(e) => {
                      this.removeImage(e, index);
                    }}
                  >
                    <DeleteIcon />
                  </Button>
                </Grid>
              ))}
          </Grid>
        </div>
        {capturedImages.length > 0 ? (
          <div>
            <Button
              disabled={consultStatus}
              className={classes.primaryButton}
              onClick={(e) => this.AcceptRejectConsultation(e, 0)}
            >
              {showInnerSpinner ? (
                <CircularProgress style={{ width: "20px !important" }} />
              ) : (
                "Accept"
              )}
            </Button>
            <Button
              disabled={consultStatus}
              onClick={(e) => {
                this.showRejection(e);
              }}
              className={classes.primaryButton}
            >
              {showInnerSpinner ? (
                <CircularProgress style={{ width: "20px !important" }} />
              ) : (
                "Reject"
              )}
            </Button>
          </div>
        ) : null}
        <Dialog open={viewerIsOpen} onClose={this.closeLightbox}>
          <DialogContent style={{ padding: "0px !important" }}>
            <img
              alt={currentImage}
              src={capturedImages[currentImage]}
              style={{ width: "550px" }}
            />
          </DialogContent>
          <DialogActions style={{ textAlign: "right" }}>
            <Button
              onClick={this.closeLightbox}
              className={classes.primaryButton}
            >
              {t("Console.MovePopup.Close")}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={viewRejectReasons}
          onClose={this.closeRejection}
          fullWidth={true}
          maxWidth={"xs"}
        >
          <DialogContent style={{ padding: "0px !important" }}>
            <FormControl style={{ width: "99%" }}>
              <FormLabel component="legend">Select reason</FormLabel>
              <Select
                value={selectedReasonId || ""}
                onChange={(e) => {
                  submitSelectedRejection(e);
                }}
                variant="standard"
                autoWidth={true}
              >
                {rejectItems.map((type) => (
                  <MenuItem
                    key={type.id}
                    value={type.id}
                    className={classes.menuItem}
                  >
                    {type.reason}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {![undefined, "undefined", null, "null", ""].includes(
              selectedReasonId
            ) &&
              selectedReasonId === "630ea51e-ca12-437e-a749-e7bc7897e96f" && (
                <FormControl style={{ width: "99%", marginTop: '15px' }}>
                  <TextField
                    id="outlined-multiline-static"
                    label="Reason"
                    multiline
                    rows={5}
                    onChange={setSelectedReasonText}
                    value={selectedReasonText}
                  />
                </FormControl>
              )}
          </DialogContent>
          <DialogActions style={{ textAlign: "right" }}>
            <Button
              onClick={(e) => this.AcceptRejectConsultation(e, 1)}
              className={classes.primaryButton}
            >
              {showInnerSpinner ? (
                <CircularProgress style={{ width: "20px !important" }} />
              ) : (
                "Reject"
              )}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

TwilioVideo.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TwilioVideo);



// WEBPACK FOOTER //
// ./src/components/TwilioProgrammableVideo/TwilioVideo.js